import { Navigate, Route, Routes } from "react-router";
import { ShowStaffViewContext } from "../App/ShowStaffViewContext";
import { SiteStatusOverview } from "../SiteStatus/SiteStatus";
import { TodosWithoutProjectIdInRoute as Todos } from "../Todos/Todos";
import { Mode } from "../Todos/Todos.types";
import { AdminDashboardLayout } from "./AdminDashboardLayout/AdminDashboardLayout";
import { AiChatFeedback } from "./AiChatFeedback/AiChatFeedback";
import { LocationOverview } from "./LocationOverview/LocationOverview";
import { MeteringServiceProviderTable } from "./MeteringServiceProviderTable/MeteringServiceProviderTable";

enum AdminDashboardTab {
  UniversalTodos = "aufgaben",
  SiteStatus = "liegenschaftsuebersicht",
  LocationOverview = "lokationsuebersicht",
  MeteringServiceProvider = "messstellenbetreiber",
  AiChatFeedback = "opti-agent-feedback"
}

const UNIVERSAL_TODOS_VARIANT_ID = 321;
const UNIVERSAL_TODOS_PROJECT_ID = "c34bf701-657b-42ba-a4f5-87d34265b94a";

const Liegenschaftsuebersicht = (
  <SiteStatusOverview title="Liegenschaftsübersicht" />
);
const ElementTodos = (
  <Todos
    mode={Mode.Universal}
    projectId={UNIVERSAL_TODOS_PROJECT_ID}
    variantId={UNIVERSAL_TODOS_VARIANT_ID}
  />
);

function AdminDashboard() {
  return (
    <AdminDashboardLayout>
      <div className="AdminDashboard">
        <ShowStaffViewContext.Provider value={true}>
          <Routes>
            <Route
              element={
                <Navigate replace to={AdminDashboardTab.UniversalTodos} />
              }
              index
            />
            <Route
              element={Liegenschaftsuebersicht}
              path={AdminDashboardTab.SiteStatus}
            >
              <Route element={Liegenschaftsuebersicht} index />
              <Route element={Liegenschaftsuebersicht} path="*" />
            </Route>
            <Route
              element={ElementTodos}
              path={AdminDashboardTab.UniversalTodos}
            >
              <Route element={ElementTodos} index />
              <Route element={ElementTodos} path="*" />
            </Route>
            <Route
              element={<AiChatFeedback />}
              path={AdminDashboardTab.AiChatFeedback}
            >
              <Route element={<AiChatFeedback />} index />
              <Route element={<AiChatFeedback />} path="*" />
            </Route>
            <Route path="msb-prozess">
              <Route
                element={
                  <Navigate
                    replace
                    to={AdminDashboardTab.MeteringServiceProvider}
                  />
                }
                index
              />
              <Route
                element={<MeteringServiceProviderTable />}
                path={AdminDashboardTab.MeteringServiceProvider}
              >
                <Route element={<MeteringServiceProviderTable />} index />
                <Route element={<MeteringServiceProviderTable />} path="*" />
              </Route>
              <Route
                element={<LocationOverview />}
                path={AdminDashboardTab.LocationOverview}
              >
                <Route element={<LocationOverview />} index />
                <Route element={<LocationOverview />} path="*" />
              </Route>
            </Route>
          </Routes>
        </ShowStaffViewContext.Provider>
      </div>
    </AdminDashboardLayout>
  );
}

export { AdminDashboard };
